import React, { FunctionComponent } from 'react';
import { Col, Paragraph } from '@mlc/web-ui-toolkit';
import { HeaderRow, ProductCard, ResponsiveHeading } from './styled';
import planProfileTestIds from './PlanProfile.elements';

type Props = {
	planName: string;
};

const PlanProfileHeader: FunctionComponent<Props> = ({ planName }) => {
	return (
		<HeaderRow justifyContent="start" alignItems="baseline">
			<PlanColumn name={planName} />
			<ProductColumn hasPlanName={!!planName} />
		</HeaderRow>
	);
};

const ProductColumn = ({ hasPlanName }: { hasPlanName: boolean }) => {
	const product = (
		<Paragraph
			color="mlcOrange"
			fontSize="standard"
			fontWeight="semibold"
			paddingLeft={hasPlanName ? 4 : 0}
			marginTop={0}
			marginBottom={6}
		>
			Superannuation Plan
		</Paragraph>
	);

	return hasPlanName ? (
		<Col auto>
			<ProductCard borderLeft="mlcBorderThin" color="mlcDarkGrey60">
				{product}
			</ProductCard>
		</Col>
	) : (
		<Col auto>{product}</Col>
	);
};

const PlanColumn = ({ name }: { name: string | undefined }) => {
	return name ? (
		<Col auto>
			<ResponsiveHeading
				display="flex"
				el="h2"
				color="mlcVeryDarkGrey"
				fontSize="regular"
				fontWeight="semibold"
				marginBottom={6}
				style={{ maxWidth: '715px' }}
				marginTop={0}
				data-id={planProfileTestIds.planName}
			>
				{name}
			</ResponsiveHeading>
		</Col>
	) : null;
};

export default PlanProfileHeader;
